import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StageTambourContent } from "@/pages/StageTambour";

const CreerSonTambour = () => {
  const [state, setState] = useState(null);
  useEffect(() => { api.tunnelTambour().then(setState).catch(() => setState(false)); }, []);
  if (state === false) return <main className="pt-40 pb-32 px-6 text-center" data-testid="funnel-unavailable"><h1 className="font-serif text-4xl text-bark">Cette page n’est pas disponible actuellement.</h1></main>;
  return <div data-testid="drum-funnel-page"><StageTambourContent /></div>;
};
export default CreerSonTambour;
